var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertCaution = function SvgAlertCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F6",
    d: "M50.777 70.408c6.693 0 12.12-5.43 12.12-12.13 0-6.699-5.427-12.13-12.12-12.13-6.694 0-12.12 5.431-12.12 12.13s5.426 12.13 12.12 12.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7F0",
    d: "M12.807 42.788a6.065 6.065 0 0 0 6.06-6.07 6.065 6.065 0 0 0-6.06-6.07 6.065 6.065 0 0 0-6.06 6.07 6.065 6.065 0 0 0 6.06 6.07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3C0BE",
    d: "M57.947 38.43 47.387 27a2.79 2.79 0 0 1 1.51-4.64l14.46-2.84a2.79 2.79 0 0 1 3.22 3.48l-3.9 14.23a2.79 2.79 0 0 1-4.73 1.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41.947 6.439 23.83 41.39a5.1 5.1 0 0 1-4.42 7.65h-47.69a5.1 5.1 0 0 1-4.41-7.65l23.87-41.39a5.09 5.09 0 0 1 8.82 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M61.397 56.227h-47.73a5.85 5.85 0 0 1-5.06-8.78l23.87-41.39a5.84 5.84 0 0 1 10.12 0l23.86 41.39a5.85 5.85 0 0 1-5.06 8.78m-23.86-51.59a4.29 4.29 0 0 0-3.76 2.17l-23.87 41.39a4.349 4.349 0 0 0 3.76 6.53h47.73a4.36 4.36 0 0 0 3.77-6.53l-23.87-41.39a4.3 4.3 0 0 0-3.76-2.17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M37.537 43.484a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#040222",
    d: "M37.536 23.36a2.27 2.27 0 0 0-2.27 2.43l.63 9.45a1.66 1.66 0 0 0 1.64 1.48 1.65 1.65 0 0 0 1.63-1.48l.64-9.45a2.28 2.28 0 0 0-2.27-2.43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3C0BE",
    d: "M70.696 6.103a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22M30.906 62h-20.34a.75.75 0 0 1 0-1.5h20.34a.75.75 0 0 1 0 1.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M23.227 4.637a.74.74 0 0 1-.6-.31l-2.32-3.13a.74.74 0 0 1 .16-1.05.73.73 0 0 1 1 .16l2.32 3.13a.74.74 0 0 1-.16 1.05.73.73 0 0 1-.4.15M8.567 26.358h-.13l-7.51-1.3a.75.75 0 0 1-.61-.86.76.76 0 0 1 .86-.62l7.52 1.3a.75.75 0 0 1-.13 1.49z"
  })));
};
export default SvgAlertCaution;